import React from 'react';
import OptionItem from './option-item.component';
import { TEST_OPTIONS } from '../constants';
import { useTestSearchContext } from '../contexts/test-search.context';

const TestSelection = () => {
    const { testType, setTestType } = useTestSearchContext();

    const handleSelection = (value) => {
        setTestType(value);
    };

    const options = TEST_OPTIONS.map((opt, i) => <OptionItem key={i} {...opt} onSelect={handleSelection} isChecked={testType === opt.value} />);
    return (
        <div className='test-selection-container'>
            <div className="space-around">{options}</div>
        </div>
    );
};

export default TestSelection;